/* Shared empty-list placeholder. */
import React from "react";

function EmptyState({ title, description, cta, icon }) {
  return (
    <div
      style={{
        padding: "48px 24px",
        textAlign: "center",
        background: "var(--paper-2)",
        border: "1px solid var(--line)",
        borderRadius: 12,
        color: "var(--ink-3)",
      }}
    >
      {icon && <div style={{ marginBottom: 12, opacity: 0.7 }}>{icon}</div>}
      {title && (
        <h3 style={{ margin: "0 0 6px", fontSize: 16, color: "#0a0a0a" }}>
          {title}
        </h3>
      )}
      {description && (
        <p style={{ margin: "0 auto", maxWidth: 360, fontSize: 14, lineHeight: 1.5 }}>
          {description}
        </p>
      )}
      {cta && (
        <div style={{ marginTop: 16 }}>
          {cta.href ? (
            <a className="btn btn-outline btn-sm" href={cta.href}>{cta.label}</a>
          ) : (
            <button className="btn btn-outline btn-sm" type="button" onClick={cta.onClick}>
              {cta.label}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export { EmptyState };
export default EmptyState;
